/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import {
  Activity, Heart, Footprints, Droplets, Scale, Wind, Moon, Thermometer,
  Watch, Smartphone, Pencil,
} from 'lucide-react';

export const METRICS = [
  { key: 'heart_rate',    label: 'Battito cardiaco',   unit: 'bpm',   Icon: Heart },
  { key: 'steps',         label: 'Passi',              unit: 'passi', Icon: Footprints },
  { key: 'systolic_bp',   label: 'Pressione sistolica', unit: 'mmHg', Icon: Activity },
  { key: 'diastolic_bp',  label: 'Pressione diastolica', unit: 'mmHg', Icon: Activity },
  { key: 'spo2',          label: 'Saturazione O₂',     unit: '%',     Icon: Wind },
  { key: 'glucose_mg_dl', label: 'Glicemia',           unit: 'mg/dl', Icon: Droplets },
  { key: 'weight_kg',     label: 'Peso',               unit: 'kg',    Icon: Scale },
  { key: 'sleep_hours',   label: 'Sonno',              unit: 'ore',   Icon: Moon },
  { key: 'temperature_c', label: 'Temperatura',        unit: '°C',    Icon: Thermometer },
];

const PROVIDER_ICONS = { apple_health: Watch, google_fit: Smartphone };
export const providerIcon = (id) => PROVIDER_ICONS[id] || Pencil;

export const metricMeta = (key) => METRICS.find((m) => m.key === key) || { key, label: key, unit: '', Icon: Activity };
